<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      ref="resourceGrid"
      color="amber"
      icon="mdi-home-group"
      plural-name="Groups"
      singular-name="Group"
      allow-expand
      fullscreen-edit
      :headers="headers"
      :resource="groupResource"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:editForm="editForm">
        <v-row>
          <v-col
            cols="12"
          >
            <group-wizard
              :edited-item="editForm.editedItem"
              @group:saved="groupSaved"
              @wizard:finished="closeEditDialog"
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:actionButtons>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </template>
    </base-resource-grid>
    <base-history-dialog
      id-field="groupId"
      title-field="groupName"
      color="amber"
      :resource-endpoint="historyEndpoint"
      :columns="historyHeaders"
      :item="historyItem"
      @hide="historyItem = null"
    >
      <template v-slot:header>
        <v-card>
          <v-tabs
            background-color="amber accent-4"
            center-active
            center
          >
            <v-tab
              @click="setHistoryTab('group')"
            >
              Group
            </v-tab>
            <v-tab
              @click="setHistoryTab('broker')"
            >
              Broker
            </v-tab>
            <v-tab
              @click="setHistoryTab('roles')"
            >
              Roles
            </v-tab>
          </v-tabs>
        </v-card>
      </template>
    </base-history-dialog>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'Groups',

    components: {
      GroupWizard: () => import('./components/GroupWizard'),
    },

    data: () => ({
      historyTab: 'group',

      headers: [
        {
          text: 'Group Name',
          value: 'groupName',
        },
        {
          text: 'Business Name',
          value: 'legalBusinessName',
        },
      ],

      brokerHeaders: [
        {
          text: 'Group Name',
          value: 'groupName',
        },
        {
          text: 'Broker',
          value: 'broker',
        },
      ],

      rolesHeaders: [
        {
          text: 'Group Name',
          value: 'groupName',
        },
        {
          text: 'Role',
          value: 'troodyRoleName',
        },
        {
          text: 'Name',
          value: 'userName',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      groupResource: new TroodyApi('group/'),

      historyItem: null,
    }),

    computed: {
      historyHeaders () {
        let output = this.headers
        switch (this.historyTab) {
          case 'broker':
            output = this.brokerHeaders
            break
          case 'roles':
            output = this.rolesHeaders
            break
          default:
            output = this.headers
            break
        }
        return output
      },

      historyEndpoint () {
        let output = 'groupHistory/'
        switch (this.historyTab) {
          case 'broker':
            output = 'brokerGroupHistory/'
            break
          case 'roles':
            output = 'groupRoleHistory/'
            break
          default:
            output = 'groupHistory/'
            break
        }
        return output
      },
    },

    methods: {
      setHistoryTab (tab) {
        this.historyTab = tab
      },

      closeEditDialog () {
        this.$refs.resourceGrid.close()
      },

      groupSaved (data) {
        this.$refs.resourceGrid.itemEdited(data)
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },
    },
  }
</script>
